
import { Modal } from '@mui/material'
import { VerifySingleSignOn } from 'api/authentication'
import Cookies from 'js-cookie'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { RESET_STATE } from 'store/actions'
import { checkForDomain, findFirstTrueValue, getFirstRoute, setInvestorID, setTokenForAuthorization } from 'utils/index'
import Wrapper from 'views/onboarding/Wrapper'

// What /logout clears, cleared inline below instead of navigating there.
const SESSION_COOKIES = ['X-INV-JWT', 'X-INV-ID', 'is_profile_complete', 'email', 'userDetails', 'step'];

const SingleSignOn = () => {
    const { mutateAsync: verifySSO, isLoading } = VerifySingleSignOn()
    const [params] = useSearchParams();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const currentLOcation = window.location.pathname;
    const currentIP = window.location.host;
    React.useEffect(() => {
        // Hold the token in a local: the cookie wipe below clears it on any host where it
        // isn't set on a parent domain (localhost), and reading it back sent an undefined
        // token to authorize-v2.
        const accessToken = params.get("access-token");
        // mutateAsync
        if (accessToken && accessToken?.length > 0) {
            Cookies.set("access-token", accessToken, { domain: checkForDomain() });
            if (currentIP?.includes("localhost")) {
                Cookies.set("access-token", accessToken);
            }
            const cookies = document.cookie.split(";");
            cookies.forEach(cookie => {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            });
            // Clear the old session here rather than routing through /logout: that screen
            // wipes cookies and navigates to /login on mount, racing the token this flow
            // is about to set, and stranded the user there whenever the call below failed.
            dispatch({ type: RESET_STATE });
            SESSION_COOKIES.forEach((name) => {
                Cookies.remove(name, { path: '/' });
                Cookies.remove(name, { domain: checkForDomain() });
            });

            verifySSO({ "token": accessToken }).then((SuccessResponse) => {

                const response = SuccessResponse?.data?.data;
               
                if (currentIP?.includes("localhost")) {
                    if (response?.collaborator_data?.connected_id) {
                        setInvestorID(response?.collaborator_data?.connected_id);
                    }
                    setTokenForAuthorization(accessToken);
                }
                // Session to be same for current users:
                if (response?.collaborator_data?.connected_id) {
                    setInvestorID(response?.collaborator_data?.connected_id, checkForDomain());
                }
                setTokenForAuthorization(accessToken, checkForDomain());
                // if (response?.collaborator_data?.connected_id) {
                //     Cookies.set(cookiesInUse["JWT"], response?.collaborator_data?.connected_id, { domain: checkForDomain() });
                // }
                // Cookies.set("step", response?.step)
                Cookies.set("is_profile_complete", true);
                navigate("/profile", { replace: true })
            }).catch(() => {
                // Sign-on failed - land on login rather than a spinner that never resolves.
                navigate("/login", { replace: true })
            })
        }
    }, [params.get("access-token")])
    // console.log(params.get("access-token"), "ttttt")

    return (
        <Modal open={isLoading}>
            <Wrapper className="skeleton" style={{
                display: 'grid', height: '100vh',
                width: "100vw",
                placeItems: 'center'
            }}>
                {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
            </Wrapper>
        </Modal>
    )
}

export default SingleSignOn